import {IntercomDashboardComponent} from '@alquilatucancha/backoffice-integration';

const moduleName = 'intercom.dashboard';

angular.module(moduleName, [])
    .directive('intercomDashboard', ['Backoffice', (Backoffice) => ({
        restrict: 'A',
        scope: {
            intercomData: '='
        },
        link: (scope, el) => {
            const info = scope.intercomData.getClubInfo();

            Backoffice.renderComponent(el[0], IntercomDashboardComponent, info, {
                silent: true,
            });

            // Al destruirse, desmontar el root de React (evita fugas en body).
            scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]);
            });
        },
    })
    ]);

export default moduleName;
